import { IsEnvelope } from "../geography/geography.interfaces";
import { TileAddress } from "./address/tiles.address";
import { Envelope } from "../geography/geography.envelope";
import { Bounds } from "../geometry";
export class TileCollection {
    static Empty() {
        return new TileCollection();
    }
    constructor(...items) {
        this._items = items;
    }
    get namespace() {
        return this._ns ?? "";
    }
    set namespace(ns) {
        this._ns = ns;
    }
    get count() {
        return this._items.length;
    }
    get index() {
        if (!this._index) {
            this._index = this._buildIndex();
        }
        return this._index;
    }
    get geoBounds() {
        if (!this._bounds) {
            this._bounds = this._buildBounds();
        }
        return this._bounds;
    }
    get boundingBox() {
        if (!this._rect) {
            this._rect = this._buildRect();
        }
        return this._rect;
    }
    has(address) {
        return this.index.has(address.quadkey);
    }
    get(address) {
        return this.index.get(address.quadkey);
    }
    getAll(...address) {
        return address.map((a) => this.get(a));
    }
    add(tile) {
        if (!this.has(tile.address)) {
            this._items.push(tile);
            this._index?.set(tile.quadkey, tile);
            const b = tile.geoBounds;
            if (b && this._bounds) {
                this._bounds.unionInPlace(b);
            }
            const r = tile.boundingBox;
            if (r && this._rect) {
                this._rect.unionInPlace(r);
            }
        }
    }
    addAll(...tiles) {
        for (const t of tiles) {
            this.add(t);
        }
    }
    remove(address) {
        if (this.has(address)) {
            const index = this._items.findIndex((t) => TileAddress.IsEquals(t.address, address));
            this._items.splice(index, 1);
            this._bounds = undefined;
            this._rect = undefined;
            this._index?.delete(address.quadkey);
        }
    }
    removeAll(...address) {
        for (const a of address) {
            this.remove(a);
        }
    }
    clear() {
        this._items = [];
        this._bounds = undefined;
        this._rect = undefined;
    }
    intersect(bounds) {
        if (!bounds)
            return this[Symbol.iterator]();
        let pointer = 0;
        let items = this._items;
        if (IsEnvelope(bounds)) {
            if (this.geoBounds?.intersects(bounds)) {
                return {
                    next() {
                        while (pointer < items.length) {
                            let item = items[pointer++];
                            let b = item.geoBounds;
                            if (!b || bounds.intersects(b)) {
                                return {
                                    done: false,
                                    value: item,
                                };
                            }
                        }
                        return {
                            done: true,
                            value: null,
                        };
                    },
                    [Symbol.iterator]() {
                        return this;
                    },
                };
            }
        }
        else {
            if (this.boundingBox?.intersects(bounds)) {
                return {
                    next() {
                        while (pointer < items.length) {
                            let item = items[pointer++];
                            let r = item.boundingBox;
                            if (!r || bounds.intersects(r)) {
                                return {
                                    done: false,
                                    value: item,
                                };
                            }
                        }
                        return {
                            done: true,
                            value: null,
                        };
                    },
                    [Symbol.iterator]() {
                        return this;
                    },
                };
            }
        }
        return {
            next() {
                return {
                    done: true,
                    value: null,
                };
            },
            [Symbol.iterator]() {
                return this;
            },
        };
    }
    [Symbol.iterator]() {
        let pointer = 0;
        let items = this._items;
        const iterator = {
            next() {
                if (pointer < items.length) {
                    return {
                        done: false,
                        value: items[pointer++],
                    };
                }
                return {
                    done: true,
                    value: null,
                };
            },
            [Symbol.iterator]() {
                return this;
            },
        };
        return iterator;
    }
    _buildIndex() {
        const index = new Map();
        for (let i = 0; i < this._items.length; i++) {
            const t = this._items[i];
            index.set(t.quadkey, t);
        }
        return index;
    }
    _buildBounds() {
        return Envelope.FromEnvelopes(...this._items);
    }
    _buildRect() {
        return Bounds.FromBounds(...this._items);
    }
}
//# sourceMappingURL=tiles.collection.js.map